import { render, staticRenderFns } from "./ChangeAuditor.vue?vue&type=template&id=6a30b0e8&"
import script from "./ChangeAuditor.vue?vue&type=script&lang=js&"
export * from "./ChangeAuditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports